import { BiSolidError } from "react-icons/bi";
import PrimaryButton from "../Forms/PrimaryButton";
import { useNavigate } from "react-router-dom";

const Verification = ({ isOpen, closeModal, signUp }) => {
  const navigate=useNavigate()
  if (!isOpen) return null;
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };
  const navivateOnLogin=()=>{
   navigate("/login")
  }
  const getClick=()=>{

  }
  return (
    <>
      <div
        onClick={signUp? getClick : handleOverlayClick}
        id="default-modal"
        className="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-40"
      >
        <div className="relative rounded-2xl p-4 w-full h-80 model-img max-w-xl max-h-full">
           <div className="p-4 md:p-5 space-y-4 ">
           {signUp && (
             <div className="flex justify-center">
            <BiSolidError color="a33434" size={100}></BiSolidError>
            </div>
           )} 
            <div className="w-full mt-44 flex text-2xl justify-center font-[400] items-baseline p-4 md:p-5">
             Account Verification Pending
            </div>
               {signUp && (<div className="flex justify-center">
                  <PrimaryButton
                    btnType={"primary"}
                    text={"OK"}
                    onClick={navivateOnLogin}
                    noIcon
                  />   
            </div>)} 
          </div>
        </div>
      </div>
    </>
  );
};

export default Verification;
